
const SET_SUB_DOMAIN = (state,sub_domain) => {
	state.sub_domain = sub_domain
}

const SET_EVENT = (state,event) => {
	state.event = event
}

const SET_LOG = (state,log) => {
	state.log = log
}

const SET_PCMSO = (state,pcmso) => {
	state.pcmso = pcmso
}

const SET_LOCATION = (state,location) => {
	state.location = location
}

const SET_NAVIGATION = (state, navigation) => {
	state.navigation = navigation
}

const SET_ENV = (state, env) => {
	state.env = env
}

const SET_URL_API = (state, url_api) => {
	state.url_api = url_api
}

const SET_WINDOW = (state, window) => {
	state.window = window
}

const SET_DEVICE = (state, device) => {
	state.device = device
}

const SET_REQUEST = (state, request) => {
	state.request = request
}

export{
	SET_SUB_DOMAIN,
	SET_LOG,
	SET_LOCATION,
	SET_NAVIGATION,
	SET_ENV,
	SET_URL_API,
	SET_WINDOW,
	SET_DEVICE,
	SET_REQUEST,
	SET_EVENT,
	SET_PCMSO
}



// WEBPACK FOOTER //
// ./src/store/common/mutations.js